module.exports = "<div class=nn-splashimage-modal ng-if=showModal() ng-click=$parent.close()><img class=nn-splashimage-modal_bg ng-src=\"{{ $parent.src }}\"> <img class=nn-splashimage-modal_fg src=assets/img/nowness-mesh-fg.png></div>"


//////////////////
// WEBPACK FOOTER
// ./app/components/nn-modals/nn-splashimage-modal/nn-splashimage-modal.directive.html
// module id = 982
// module chunks = 0